import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import * as fromActions from "./form-fixed-response.actions"
import * as fromGraphql from "./form-fixed-response.graphql"
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {map, switchMap} from 'rxjs';
import {GET_FORM_FIXED_RESPONSE} from "./form-fixed-response.graphql";

@Injectable()
export class FormFixedResponseEffects {
  createFormFixedResponse$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createFormFixedResponseMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_FORM_FIXED_RESPONSE,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {
          if(data){
            const result: any = Object.values(data)[0];
            if (result?.response?.status) {
              this.store.dispatch(fromActions.upsertFormFixedResponse({ formFixedResponse : result?.data }));
              await this.notificationService.successMessage(result?.responses?.message);
            } else{
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      )
})
  ), {dispatch: false})

  getFormFixedResponse$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getFormFixedResponse),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_FORM_FIXED_RESPONSE,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action?.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching fillable forms'),
        map(async ({ data }: any) => {
          if(data){
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadFormFixedResponses({ formFixedResponses: result?.data })) : []
          }
        })
      )
    })
  ), {dispatch: false})

  updateFormFixedResponse$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateFormFixedResponseMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_FORM_FIXED_RESPONSE,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {
          if(data){
            const result: any = Object.values(data)[0];
            if (result?.response?.status) {
              this.store.dispatch(fromActions.upsertFormFixedResponse({ formFixedResponse : result?.data }));
              await this.notificationService.successMessage(result?.responses?.message);
            } else{
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      )
    })
  ), {dispatch: false})

  deleteFormFixedResponse$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.deleteFormFixedResponseMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_FORM_FIXED_RESPONSE,
        variables: {
          uniqueId: action?.uniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.status) {
              this.store.dispatch(fromActions.deleteFormFixedResponse({ id: action?.id }));
              await this.notificationService.successMessage('Deleted Successfully');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), {dispatch: false})

  constructor( private actions$: Actions,
               private apollo: Apollo,
               private store: Store<AppState>,
               private notificationService: NotificationService,) {}
}
